import { useQuery } from '@apollo/client';

import findAssetViewQuery from './findAssetViewQuery.graphql';

export default function useFindAssetViewQuery(options) {
  return useQuery(findAssetViewQuery, options);
}
